import $axios from "./axios";

//列表页
export const getList = (data: any) => {
  return $axios({
    method: "POST",
    url: "v1/contents",
    data: data,
  });
};
//详情
export const getDesc = (id: any) => {
  return $axios({
    method: "GET",
    url: "v1/contents/1/9/" + id,
    data: {},
  });
};
